import styled from "styled-components/macro";

import { TinyText } from "shared/styles";

export const StyledCalendarListDate = styled(TinyText)`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 24px;
`;
